import React, { useRef } from "react";
import { Dropdown, FormField, FormGroup, Input, Radio, SemanticWIDTHS } from "semantic-ui-react";
import { OfficialAccountAddressDataType } from "./OfficialAccountAddressForm";

type AccountingInformationFormProps = {
  detail: OfficialAccountAddressDataType;
  readOnly?: boolean;
  error?: Record<string, any>;
  businessTypeWidth?: SemanticWIDTHS;
  width?: SemanticWIDTHS;
  requiredTextError?: (isRequired: boolean) => React.ReactNode;
  handleChangeValue?: (e?: any, data?: any) => void;
  languageUX?: "en" | "th";
};

const AccountingInformationForm = (props: AccountingInformationFormProps) => {
  const accountingData = props.detail.accounting;

  return (
    <>
      <FormGroup inline>
        {!!props.width && (
          <FormField width={props.width} required>
            <label>{"ชื่อธุรกิจ"}</label>
          </FormField>
        )}

        <FormField
          width={props.width ? 8 : 11}
          inline
          required
          style={{ display: "flex", alignItems: "center" }}
        >
          {!props.width && <label>{"ชื่อธุรกิจ"}</label>}

          <div style={{ display: "grid", width: "100%" }}>
            <FormField width={16}>
              <Input
                name="accounting.accounting_business_name"
                placeholder="ชื่อธุรกิจ"
                value={accountingData?.accounting_business_name || ""}
                onChange={props.handleChangeValue}
                disabled={props.readOnly}
                error={props.error?.accounting_business_name}
              />
            </FormField>

            <FormField width={16}>
              {props.requiredTextError?.(props.error?.accounting_business_name)}
            </FormField>
          </div>
        </FormField>
      </FormGroup>

      <FormGroup inline>
        {!!props.width && (
          <FormField width={props.width} required>
            <label>เลขประจำตัวผู้เสียภาษี</label>
          </FormField>
        )}
        <FormField width={11} inline required error={props.error?.accounting_tax_payer_id ?? false}>
          {!props.width && <label>เลขประจำตัวผู้เสียภาษี</label>}
          <div style={{ display: "grid" }}>
            <div style={{ display: "flex" }}>
              {Array.from({ length: 13 }).map((_, index) => {
                const extraMargin = [0, 4, 9].includes(index) ? 15 : 0;
                const rawTax = props.detail.accounting?.accounting_tax_payer_id || "";
                const taxIdArray = rawTax.padEnd(13, " ").split("");
                return (
                  <Input
                    key={index}
                    name="accounting.accounting_tax_payer_id"
                    id={`Accounting-TaxID-${index}`}
                    value={taxIdArray[index] === " " ? "" : taxIdArray[index]}
                    disabled={props.readOnly}
                    style={{
                      width: "40px",
                      textAlign: "center",
                      marginRight: extraMargin,
                    }}
                    input={{ type: "text", maxLength: 1 }}
                    onChange={(e) => {
                      const digit = e.target.value.replace(/\D/g, "").slice(0, 1);
                      let arr = (props.detail.accounting?.accounting_tax_payer_id || "")
                        .padEnd(13, " ")
                        .split("");
                      arr[index] = digit || " ";

                      props.handleChangeValue?.(e, {
                        name: "accounting.accounting_tax_payer_id",
                        value: arr.join(""),
                      });

                      if (digit && index < 12) {
                        document.getElementById(`Accounting-TaxID-${index + 1}`)?.focus();
                      }
                    }}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                      if (e.key === "Backspace") {
                        const arr = (props.detail.accounting?.accounting_tax_payer_id || "")
                          .padEnd(13, " ")
                          .split("");
                        const current = arr[index];

                        if ((current === " " || current === "") && index > 0) {
                          const prevInput = document.getElementById(
                            `Accounting-TaxID-${index - 1}`,
                          ) as HTMLInputElement | null;
                          prevInput?.focus();
                          e.preventDefault();
                        }
                      }
                    }}
                  />
                );
              })}
            </div>
            <div>{props.requiredTextError?.(props.error?.accounting_tax_payer_id)}</div>
          </div>
        </FormField>
      </FormGroup>
    </>
  );
};

export default AccountingInformationForm;
